import React from "react";
import { getFileIcon } from "@pages/Project/components/Tabs/FileUploadTab"; // Adjust path if needed
import { Option } from "./AssistantForm";

interface ReadOnlySelectedFilesViewProps {
  selected: Option[];
}

const getExtension = (filename: string) => {
  const parts = filename.split(".");
  return parts.length > 1 ? parts.pop() || "" : "";
};

const ReadOnlySelectedFilesView: React.FC<ReadOnlySelectedFilesViewProps> = ({
  selected,
}) => {
  if (!selected.length) return null;

  if (selected.length === 1) {
    const ext = getExtension(selected[0].name);
    return (
      <div className="flex space-x-1.5 items-center bg-[#FFFFFE] border border-[#E4E7EC] text-gray-900 font-medium p-2.5 rounded-md text-xs 2xl:text-sm">
        <img
          src={getFileIcon(ext)}
          className="2xl:w-6 2xl:h-6 h-5 w-5"
          alt=""
        />
        <p className="mt-1">{selected[0].name}</p>
      </div>
    );
  }

  // Multiple selected
  return (
    <div className="group relative w-fit">
      <div className="flex space-x-1.5 cursor-pointer items-center bg-[#FFFFFE] border border-[#E4E7EC] text-gray-900 font-medium p-2.5 rounded-md text-xs 2xl:text-sm">
        <img src="/file.svg" className="2xl:w-6 2xl:h-6 h-5 w-5" alt="" />
        <p className="mt-1">Multiple documents ({selected.length})</p>
      </div>

      <div className="hidden group-hover:block top-full absolute z-50 mt-2 w-56 2xl:w-64 bg-white rounded-md shadow-lg border border-gray-200">
        <div className="max-h-60 overflow-y-auto scrollbar-hide py-2">
          {selected.map((opt) => {
            const ext = getExtension(opt.name);
            return (
              <div
                key={opt.id}
                className="px-3 py-2 flex items-center  text-gray-900 text-xs 2xl:text-sm"
              >
                <img src={getFileIcon(ext)} alt="" className="h-5 w-5 mr-2" />
                <p className="break-all whitespace-normal">{opt.name}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ReadOnlySelectedFilesView;
